module.exports = __webpack_public_path__ + "img/57.8e9bee17.jpg";